<script setup lang="ts">
import { getEnv, } from '@/utils/env';
import { onBeforeMount, onErrorCaptured, onMounted, } from 'vue';
import { useSessionStore, } from '@/store';
import ErrorState from '@/components/Error.vue';
import { ERROR_PAGE_TYPE, } from '@/enums/configs';
import {
  captureRouteContentError,
  routeContentError,
} from '@/router/routeError';

const sessionStore = useSessionStore();

onErrorCaptured(() => {
  captureRouteContentError('component');
});

const reloadPage = () => {
  window.location.reload();
};

onBeforeMount(async () => {
  const env = await getEnv();

  sessionStore.getAccessToken();

  if (env && env !== 'prod') {
    // eslint-disable-next-line import/no-extraneous-dependencies
    const { default: VConsole, } = await import('vconsole');

    // eslint-disable-next-line no-new
    new VConsole();
  }
});

onMounted(() => {
  window.onload = () => {
    document.addEventListener('touchstart', (event) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    document.addEventListener('gesturestart', (event) => {
      event.preventDefault();
    });
  };
});
</script>

<template>
  <div class="routers">
    <ErrorState
      v-if="routeContentError"
      :type="ERROR_PAGE_TYPE.ERROR"
      action-text="重新加载"
      @refresh="reloadPage"
    />
    <router-view v-else />
  </div>
</template>

<style lang="scss">

</style>

<style lang="scss" scoped>

</style>
